import { Button } from '../../cdl/Button/Button';
import { Text } from '../../cdl/Text/Text';
import { AuthenticationPageContentBox } from '../../login/components/AuthenticationPageContentBox';
import { translate } from '../helpers/translate.helper';
import { useOpenFreshchat } from '../hooks/useOpenFreshchat';
import { Box } from '../ui/Box';

export const UnauthenticatedNotFoundErrorPage = () => {
    const openFreshchat = useOpenFreshchat();

    return (
        <AuthenticationPageContentBox>
            <Text variant="title" as="h1">
                {translate('error.public.notFound.title')}
            </Text>
            <Text as="p" variant="small" color="foreground.muted">
                {translate('error.public.notFound.description')}
            </Text>
            <Box marginTop={24}>
                <Button emphasis="high" type="submit" onClick={() => openFreshchat()}>
                    {translate('error.public.contactSupport')}
                </Button>
            </Box>
        </AuthenticationPageContentBox>
    );
};
